<template>
    <div>
        <div class="m-portlet m-b-10">
            <div class="m-portlet__body">
                <el-form label-width="100px">
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-form-item label="筛选员工">
                                <el-select v-model="$parentInfo.Dialog_GrantShop.filter.employee_id" placeholder="员工"
                                           clearable
                                           filterable remote
                                           :remote-method="handelSearchByEmployeeName"
                                           @change="handleInfo()">
                                    <el-option
                                            v-for="item in employees"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <div class="m-portlet m-b-10">
            <div class="m-portlet__body">
                <el-table
                        :data="orderGrantInvoices"
                        style="width: 100%"
                        size="middle"
                        :height="450"
                >
                    <el-table-column label="" width="65">
                        <template scope="scope">
                            <el-radio :label="scope.row.id" v-model="employeeId" @change.native="handleSelectionChange(scope.$index,scope.row)">&nbsp</el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="id" label="ID"></el-table-column>
                    <el-table-column prop="name" label="员工名"></el-table-column>
                </el-table>
                <div class="m-portlet__foot">
                    <!--分页-->
                    <div class="text-center">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="$parentInfo.Dialog_GrantShop.currentPage"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="$parentInfo.Dialog_GrantShop.total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <div style="text-align: right">
            <el-button size="mini" @click="handleAdd()">发放</el-button>
        </div>
    </div>
</template>

<script>
    import store from '@/store'
    export default {
        name: "Dialog_GrantShop",
        data() {
            return {
                employeeId:'',
                templateSelection:'',
                students:[],
                employees:[
                ],
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleInfo();
            this.handelSearchByEmployeeName();
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            orderGrantInvoices: function () {
                return this._.orderBy(this.$parentInfo.Dialog_GrantShop.grantInvoices, 'id', 'asc');
            }
        },
        methods: {
            handleInfo(currentPage = 1){
                this.$parentInfo.Dialog_GrantShop.loading = true;
                if (currentPage === 1) {
                    this.$parentInfo.Dialog_GrantShop.currentPage = 1
                }
                this.$axios.get(store.state.server + '/getTeacherDispatchList?'+
                    'employeeId='+this.$parentInfo.Dialog_GrantShop.filter.employee_id +
                    '&page='+this.$parentInfo.Dialog_GrantShop.currentPage +
                    '&limit=' + this.$parentInfo.Dialog_GrantShop.currentPageSize
                ).then((response) => {
                    if (response.data.code == '0000') {
                        this.$parentInfo.Dialog_GrantShop.grantInvoices=response.data.content.list
                        this.$parentInfo.Dialog_GrantShop.total=response.data.content.total
                        this.$parentInfo.Dialog_GrantShop.loading = false;
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handleInit(){

            },
            handleChange(){

            },
            handleSelectionChange(index,row) {
                this.templateSelection = row;
            },
            handleSizeChange(val) {
                this.$parentInfo.Dialog_GrantShop.currentPageSize = val;
                this.handleInfo(this.$parentInfo.Dialog_GrantShop.currentPage, this.$parentInfo.Dialog_GrantShop.currentPageSize)
            },
            handleCurrentChange(val) {
                this.$parentInfo.Dialog_GrantShop.currentPage = val;
                this.handleInfo(this.$parentInfo.Dialog_GrantShop.currentPage, this.$parentInfo.Dialog_GrantShop.currentPageSize)
            },
            handleAdd(){
                this.$axios.post(store.state.server + '/teacherDispatchShop', {
                        'shopId':this.$store.state.modal.data.shopId,
                        'employeeId':this.templateSelection.id
                    }
                ).then((response) => {
                    if (response.data.code == '0000') {
                        this.$delete(this.$parentInfo.teacherDistributions,response.data.content.employeeShop.message_id)
                        this.$message({
                            type: 'success',
                            message: '发放成功'
                        });
                        this.$Win.closeModal()
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handelSearchByEmployeeName(val=''){
                this.$axios.get(store.state.server + '/searchByTeacher?employeeName=' +val).then((response) => {
                    if (response.data.code == '0000') {
                        this.employees=response.data.content.employee
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>